module.exports = __webpack_public_path__ + "components/flag/static/square/ck-10667d28e16381611fa912fa78cecca7.svg";